import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLink, FiCheckSquare, FiTruck } = FiIcons;

const partners = [
  {
    title: 'Authorized Channel Sourcing',
    text: 'We procure exclusively through verified distributor networks, eliminating gray-market risks and ensuring full OEM warranty and TAA compliance.',
    icon: FiLink
  },
  {
    title: 'High-Compliance Focus',
    text: 'Our operations are structured to meet the rigorous reporting, security, and diversity requirements of federal, state, and institutional buyers.',
    icon: FiCheckSquare
  },
  {
    title: 'Secure Logistical Execution',
    text: 'We manage the end-to-end supply chain—from initial quote to final deployment—optimizing chain-of-custody and reducing procurement friction.',
    icon: FiTruck
  }
];

export default function Trust() {
  return (
    <section className="bg-white py-24 border-b border-slate-100">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold tracking-tight text-slate-800">The MelonEdge Advantage</h2>
        </div>
        
        <div className="grid gap-8 lg:grid-cols-3">
          {partners.map((p, idx) => (
            <motion.div 
              key={p.title}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="rounded-[2rem] bg-slate-50/50 p-8 border border-slate-100"
            >
              <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-white border border-slate-100 text-orange-500">
                <SafeIcon icon={p.icon} className="h-6 w-6" />
              </div>
              <h3 className="text-lg font-bold text-slate-800 mb-3">{p.title}</h3>
              <p className="text-sm leading-relaxed text-slate-500">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}